<template>
  <div>
    <v-container v-if="!loading">
      <v-row align="center">
        <div v-if="agent">
          <v-data-table
            :headers="userHeaders"
            :items="items"
            hide-default-footer
          >
          </v-data-table>
        </div>
      </v-row>
      <log-dialog
        :headers="headers"
        :logData="logData"
        :showDialog="showDialog"
        :title="dialogTitle"
        :isLoading="loading"
        :csvFilename="csvFilename"
        :courseId="course.id"
      />
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    variables: {
      type: Map,
      required: true
    },
    course: {
      type: Object,
      required: true
    },
    agent: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      userHeaders: [
        { text: 'Variable Name', value: 'name' },
        { text: 'Value', value: 'value' }
      ],
      items: []
    }
  },
  mounted() {
    this.loading = true
    this.loadData()
    this.loading = false
  },
  methods: {
    loadData() {
      for (let [key, values] of this.variables) {
        for (let variable of values) {
          if (variable.userId == this.agent) {
            let item = {
              name: key,
              value: variable.value
            }
            this.items.push(item)
          }
        }
      }
    }
  }
}
</script>

<style></style>
